import { memo as Memo } from 'react';

//* Components
import Text from 'components/common/Text';

//* Style
import TextSectionStyle from './style';

const TextSection = Memo(({ className, text }) => {
	return (
		<TextSectionStyle className={`${className || ''}`}>
			<Text
				className={`uppercase h4 gilroyMedium blackRussian`}
				text={text}
			/>
		</TextSectionStyle>
	);
});

export default TextSection;
